import { apiClient, type ApiClientResponse, routes } from 'common/services';
import { type FileAssetsDataObject } from 'models/service';

export const uploadFile = async (data: FormData) =>
  apiClient.post<FileAssetsDataObject, ApiClientResponse<FileAssetsDataObject>>(routes.files.create, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
